import type { ControlPlaneApi } from '@agilelab/plugin-wb-control-plane-common';
import { createApiRef } from '@mainstage/core-plugin-api';

/**
 * API ref for {@link ControlPlaneApi}.
 *
 * Defined here (frontend-only plugin) rather than in
 * `@agilelab/plugin-wb-control-plane-common` because that common package is
 * also required at runtime by `wb-control-plane-backend`, and `createApiRef`
 * pulls in `@mainstage/core-plugin-api`'s runtime code, which is frontend-only.
 *
 * @public
 */
export const controlPlaneApiRef = createApiRef<ControlPlaneApi>({
  id: 'plugin.wb-control-plane.client',
});
